<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center>
        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center>
              <v-flex xs12 class="homeFeedContainer mt-5">
                <div>
                  <v-row class="px-5">
                    <v-col
                      v-for="(certificate, index) in data"
                      :key="index"
                      style="padding-bottom: 5px"
                      cols="6"
                    >
                      <v-card
                        :style="getBackgroundImage(index)"
                        style="border-radius: 10px; height: 100%"
                      >
                        <v-card-title
                          :style="getTextStyle()"
                          @click="handleClick(certificate)"
                        >
                          <div style="width: 80%; font-size: 24px">
                            {{ certificate.TrainingName }}
                          </div>
                          <div
                            style="
                              width: 15%;
                              font-size: 16px;
                              justify-content: center;
                              align-items: center;
                            "
                          >
                            {{ formatDate(certificate.Date) }}
                          </div>
                        </v-card-title>
                      </v-card>
                    </v-col>
                    <v-layout class="px-4" justify-center align-center>
                      <v-subheader class="defaultColor--text">{{
                        computedTitle
                      }}</v-subheader>
                    </v-layout>
                  </v-row>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import PostService from '@/services/PostService';
import moment from 'moment';
export default {
  data() {
    return {
      data: [],
      totalCount: '0',
      imagePalette: [
        { imageUrl: require('../../../public/images/academy/yellow.png') },
        { imageUrl: require('../../../public/images/academy/green.png') },
        { imageUrl: require('../../../public/images/academy/pink.png') },
        { imageUrl: require('../../../public/images/academy/orange.png') },
        { imageUrl: require('../../../public/images/academy/purple.png') },
        { imageUrl: require('../../../public/images/academy/blue.png') },
      ],
    };
  },

  mounted() {
    this.fetchCertificates();
  },
  computed: {
    computedTitle() {
      return this.$t('title.totalCount', { count: this.totalCount });
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';

      const formattedDate = moment(dateString, 'DD/MM/YYYY HH:mm:ss').format(
        'DD.MM.YYYY'
      );
      return formattedDate;
    },
    handleClick(certificate) {
      window.open(certificate.RedirectLink, '_blank');
    },
    getBackgroundImage(index) {
      const imageEntry =
        this.imagePalette[index % this.imagePalette.length].imageUrl;
      let imageUrl;

      if (typeof imageEntry === 'string') {
        imageUrl = imageEntry;
      } else if (imageEntry.default) {
        imageUrl = imageEntry.default;
      } else {
        console.error('Invalid image entry:', imageEntry);
        return {};
      }

      return {
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      };
    },
    fetchCertificates() {
      setPageLoading(true);
      PostService.getCertificates(this.$store.state.username)
        .then((res) => {
          const data = res.data || []; 
          
          if (data[0] && data[0].TrainingName) {
            this.data = data;
            this.totalCount = data.length;
          } else {
            this.data = null;
          }
        })
        .catch((err) => {
          console.error('Error fetching certificates:', err);
        })
        .finally(() => {
          setPageLoading(false);
          console.log(this.data);
        });
    },
    getTextStyle() {
      if (this.$vuetify.breakpoint.xs) {
        return {
          color: 'white',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '14px',
        };
      } else if (this.$vuetify.breakpoint.sm) {
        return {
          color: 'white',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '16px',
        };
      } else if (this.$vuetify.breakpoint.md) {
        return {
          color: 'white',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '18px',
        };
      } else if (this.$vuetify.breakpoint.lg) {
        return {
          color: 'white',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '20px',
        };
      } else {
        return {
          color: 'white',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '22px',
        };
      }
    },
  },
};
</script>
